import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const catalogAdminImageManagementAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.ImageManagementViewAccess,
}
